export default [
    '+52'
]